export function initNavigation() {
    const lang = window.location.pathname.includes('/en/') ? 'en' : 'fr';
    
    // Configuration de Cloudflare Turnstile
    const isProduction = window.location.hostname === 'sekantial.com' || window.location.hostname.endsWith('.sekantial.com');
    const isSandboxEnv = window.location.hostname.includes('run.app') || window.location.hostname.includes('aistudio') || window.location.hostname.includes('google');
    
    // Clé de site réelle en production, ou clé de test/simulation en développement
    const TURNSTILE_SITE_KEY = isProduction ? '0x4AAAAAABt3xss_GRWGZVqo' : '1x00000000000000000000AA';
    const shouldLoadTurnstile = !isSandboxEnv;
    
    // Injecter dynamiquement le script de Turnstile s'il est configuré et que nous ne sommes pas dans le bac à sable
    if (shouldLoadTurnstile && TURNSTILE_SITE_KEY && !document.getElementById('cloudflare-turnstile-script')) {
        const script = document.createElement('script');
        script.id = 'cloudflare-turnstile-script';
        script.setAttribute('src', 'https://challenges.cloudflare.com/turnstile/v0/api.js');
        script.async = true;
        script.defer = true;
        document.head.appendChild(script);
    }
    
    const navData = {
        fr: {
            logoLink: '/fr/',
            caseStudiesLabel: 'Case Studies',
            caseStudiesLink: '/fr/case-studies.html',
            discutonsLabel: 'CONTACT',
            homeLabel: 'Accueil',
            servicesLabel: 'SERVICES',
            contactEmail: 'hello@sekantial.com',
            privacyLabel: 'Politique de confidentialité',
            privacyLink: '/fr/politique-confidentialite.html',
            legalLabel: 'Mentions légales',
            legalLink: '/fr/mentions-legales.html',
            drawerTitle: 'Travaillons ensemble !',
            formFirstname: 'Prénom',
            formLastname: 'Nom',
            formEmail: 'E-mail',
            formPhone: 'Téléphone',
            formMessage: 'De quoi souhaiteriez-vous discuter ?',
            formSubmit: 'ENVOYER',
            alertMessage: 'Merci pour votre message ! Nous reviendrons vers vous rapidement.',
            successTitle: 'Message Envoyé !',
            successSubtitle: 'Nous vous recontactons sous 24 à 48h.',
            sendingLabel: 'Envoi en cours...',
            services: [
                { name: 'GTM Engineering', link: '/fr/services/gtm-engineering.html' },
                { name: 'Stratégie GTM', link: '/fr/services/gtm-strategy.html' },
                { name: 'RevOps', link: '/fr/services/revops.html' },
                { name: 'Optimisation de CRM', link: '/fr/services/crm-opti.html' },
                { name: 'DataViz', link: '/fr/services/data.html' }
            ]
        },
        en: {
            logoLink: '/en/',
            caseStudiesLabel: 'Case Studies',
            caseStudiesLink: '/en/case-studies.html',
            discutonsLabel: "LET'S TALK",
            homeLabel: 'Home',
            servicesLabel: 'SERVICES',
            contactEmail: 'hello@sekantial.com',
            privacyLabel: 'Privacy Policy',
            privacyLink: '/en/privacy-policy.html',
            legalLabel: 'Legal Notice',
            legalLink: '/en/legal-notice.html',
            drawerTitle: "Let's work together!",
            formFirstname: 'First Name',
            formLastname: 'Last Name',
            formEmail: 'E-mail',
            formPhone: 'Phone',
            formMessage: 'What would you like to talk about ?',
            formSubmit: 'SEND REQUEST',
            alertMessage: 'Thank you for your message! We will get back to you soon.',
            successTitle: 'Message Sent!',
            successSubtitle: 'We will get back to you within 24-48h.',
            sendingLabel: 'Sending...',
            services: [
                { name: 'GTM Engineering', link: '/en/services/gtm-engineering.html' },
                { name: 'GTM Strategy', link: '/en/services/gtm-strategy.html' },
                { name: 'RevOps', link: '/en/services/revops.html' },
                { name: 'CRM Optimization', link: '/en/services/crm-opti.html' },
                { name: 'Data Visualization', link: '/en/services/data.html' }
            ]
        }
    };

    const d = navData[lang];

    const currentPath = window.location.pathname;
    const getAltLink = (toLang) => {
        if (toLang === 'en') {
            let path = currentPath.replace('/fr/', '/en/');
            if (path.includes('mentions-legales.html')) path = path.replace('mentions-legales.html', 'legal-notice.html');
            if (path.includes('politique-confidentialite.html')) path = path.replace('politique-confidentialite.html', 'privacy-policy.html');
            return path;
        } else {
            let path = currentPath.replace('/en/', '/fr/');
            if (path.includes('legal-notice.html')) path = path.replace('legal-notice.html', 'mentions-legales.html');
            if (path.includes('privacy-policy.html')) path = path.replace('privacy-policy.html', 'politique-confidentialite.html');
            return path;
        }
    };

    const navHtml = `
    <div class="fixed-nav">
      <div class="top-nav">
        <a href="${d.logoLink}" class="header-logo no-underline">
            <svg class="infinity-logo" viewBox="0 0 24 24">
                <path d="M20.288 9.463a4.856 4.856 0 0 0-4.336-2.3 4.586 4.586 0 0 0-3.343 1.767c.071.116.148.226.212.347l.879 1.652.134-.254a2.71 2.71 0 0 1 2.206-1.519 2.845 2.845 0 1 1 0 5.686 2.708 2.708 0 0 1-2.205-1.518L13.131 12l-1.193-2.26a4.709 4.709 0 0 0-3.89-2.581 4.845 4.845 0 1 0 0 9.682 4.586 4.586 0 0 0 3.343-1.767c-.071-.116-.148-.226-.212-.347l-.879-1.656-.134.254a2.71 2.71 0 0 1-2.206 1.519 2.855 2.855 0 0 1-2.559-1.369 2.825 2.825 0 0 1 0-2.946 2.862 2.862 0 0 1 2.442-1.374h.121a2.708 2.708 0 0 1 2.205 1.518l.7 1.327 1.193 2.26a4.709 4.709 0 0 0 3.89 2.581h.209a4.846 4.846 0 0 0 4.127-7.378z"/>
            </svg>
            <span class="logo-text no-underline">SEKANTIAL</span>
        </a>

        <div class="nav-right">
            <a href="${d.caseStudiesLink}" class="nav-link-v2 nav-link-v2-uppercase">${d.caseStudiesLabel}</a>
            <button class="btn-liquid toggle-contact">
                <span>${d.discutonsLabel}</span>
                <span class="liquid-bg"></span>
            </button>
            <button class="menu-btn" id="open-menu">
              <span class="line"></span>
              <span class="line"></span>
              <span class="line"></span>
            </button>
        </div>
      </div>
    </div>

    <div class="drawer" id="menu-drawer">
        <div class="drawer-header">
            <button class="close-btn" id="close-menu">✕</button>
            <div class="logo-container">
                <svg class="infinity-logo" viewBox="0 0 24 24">
                    <path d="M20.288 9.463a4.856 4.856 0 0 0-4.336-2.3 4.586 4.586 0 0 0-3.343 1.767c.071.116.148.226.212.347l.879 1.652.134-.254a2.71 2.71 0 0 1 2.206-1.519 2.845 2.845 0 1 1 0 5.686 2.708 2.708 0 0 1-2.205-1.518L13.131 12l-1.193-2.26a4.709 4.709 0 0 0-3.89-2.581 4.845 4.845 0 1 0 0 9.682 4.586 4.586 0 0 0 3.343-1.767c-.071-.116-.148-.226-.212-.347l-.879-1.656-.134.254a2.71 2.71 0 0 1-2.206 1.519 2.855 2.855 0 0 1-2.559-1.369 2.825 2.825 0 0 1 0-2.946 2.862 2.862 0 0 1 2.442-1.374h.121a2.708 2.708 0 0 1 2.205 1.518l.7 1.327 1.193 2.26a4.709 4.709 0 0 0 3.89 2.581h.209a4.846 4.846 0 0 0 4.127-7.378z"/>
                </svg>
                <span class="logo-text">SEKANTIAL</span>
            </div>
        </div>
        <div class="drawer-content">
            <div class="lang-switcher lang-switcher-v2">
                <a href="/fr/" class="${lang === 'fr' ? 'active' : ''}">FR</a>
                <a href="/en/" class="${lang === 'en' ? 'active' : ''}">EN</a>
            </div>
            <nav class="side-nav">
                <a href="${d.logoLink}">${d.homeLabel}</a>
                <a href="${d.caseStudiesLink}">${d.caseStudiesLabel}</a>
                <div class="nav-section">${d.servicesLabel}</div>
                ${d.services.map(s => `<a href="${s.link}">${s.name}</a>`).join('')}
            </nav>
            <div class="drawer-footer">
                <div class="contact-info">
                    <p><a href="mailto:${d.contactEmail}">${d.contactEmail}</a></p>
                    <a href="${d.privacyLink}">${d.privacyLabel}</a>
                    <a href="${d.legalLink}">${d.legalLabel}</a>
                </div>
                <div class="social-links">
                    <a href="#">LI</a>
                    <a href="#">FB</a>
                    <a href="#">X</a>
                </div>
            </div>
        </div>
    </div>

    <div class="drawer drawer-wide" id="contact-drawer">
        <div class="drawer-header">
            <button class="close-btn" id="close-contact">✕</button>
            <div class="logo-container">
                <svg class="infinity-logo" viewBox="0 0 24 24">
                    <path d="M20.288 9.463a4.856 4.856 0 0 0-4.336-2.3 4.586 4.586 0 0 0-3.343 1.767c.071.116.148.226.212.347l.879 1.652.134-.254a2.71 2.71 0 0 1 2.206-1.519 2.845 2.845 0 1 1 0 5.686 2.708 2.708 0 0 1-2.205-1.518L13.131 12l-1.193-2.26a4.709 4.709 0 0 0-3.89-2.581 4.845 4.845 0 1 0 0 9.682 4.586 4.586 0 0 0 3.343-1.767c-.071-.116-.148-.226-.212-.347l-.879-1.656-.134.254a2.71 2.71 0 0 1-2.206 1.519 2.855 2.855 0 0 1-2.559-1.369 2.825 2.825 0 0 1 0-2.946 2.862 2.862 0 0 1 2.442-1.374h.121a2.708 2.708 0 0 1 2.205 1.518l.7 1.327 1.193 2.26a4.709 4.709 0 0 0 3.89 2.581h.209a4.846 4.846 0 0 0 4.127-7.378z"/>
                </svg>
                <span class="logo-text">SEKANTIAL</span>
            </div>
        </div>
        <div class="drawer-content">
            <div id="contact-form-container">
                <h2 class="drawer-title">${d.drawerTitle}</h2>
                <form class="contact-form" id="main-contact-form">
                    <div class="input-wrapper">
                        <input type="text" name="firstname" id="firstname" autocomplete="given-name" placeholder="${d.formFirstname}" required minlength="2">
                    </div>
                    <div class="input-wrapper">
                        <input type="text" name="lastname" id="lastname" autocomplete="family-name" placeholder="${d.formLastname}" required minlength="2">
                    </div>
                    <div class="input-wrapper">
                        <input type="email" name="email" id="email" autocomplete="email" placeholder="${d.formEmail}" required>
                    </div>
                    <div class="input-wrapper">
                        <input type="tel" name="phone" id="phone" autocomplete="tel" placeholder="${d.formPhone}" pattern="[0-9+ \\\\.]{8,}">
                    </div>
                    <div class="input-wrapper full-width">
                        <textarea name="message" id="message" autocomplete="off" placeholder="${d.formMessage}" required minlength="10"></textarea>
                    </div>
                    ${!shouldLoadTurnstile ? 
                        '<div class="input-wrapper full-width" style="display:flex; justify-content:center;">' +
                        '<input type="hidden" name="cf-turnstile-response" value="sandbox-simulated-token-sekantial">' +
                        '<div style="background: rgba(163,230,53,0.05); border: 1px solid rgba(163,230,53,0.2); border-radius: 8px; padding: 10px 15px; display: flex; align-items: center; gap: 10px; font-family: sans-serif; font-size: 12px; color: rgba(255,255,255,0.85); width: 100%; box-sizing: border-box;">' +
                        '<span style="color: #a3e635; display: inline-flex; align-items: center; justify-content: center; width: 16px; height: 16px; border-radius: 50%; border: 1px solid #a3e635; font-size: 10px; font-weight: bold;">✔</span>' +
                        '<span>Protection Anti-Spam (Mode Aperçu Actif)</span>' +
                        '</div>' +
                        '</div>' 
                    : (TURNSTILE_SITE_KEY ? '<div class="input-wrapper full-width" style="display:flex; justify-content:center; margin-bottom:15px;"><div class="cf-turnstile" data-sitekey="' + TURNSTILE_SITE_KEY + '" data-theme="dark"></div></div>' : '')}

                    <div class="input-wrapper full-width">
                        <button type="submit" class="btn-submit btn-liquid full-width">
                            <span>${d.formSubmit}</span>
                        </button>
                    </div>

                    <div class="input-wrapper full-width">
                        <div id="form-status-message" style="text-align: center; font-size: 14px; font-weight: 500; color: var(--c-lime, #a3e635); min-height: 20px; margin-top: 10px; text-transform: uppercase;"></div>
                    </div>
                </form>
            </div>
            <div id="contact-success" class="contact-success-v2">
                <div class="success-icon-wrapper success-icon-box">
                    <svg width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="var(--c-lime)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                        <polyline points="22 4 12 14.01 9 11.01"></polyline>
                    </svg>
                </div>
                <h2 class="success-title-v2">${d.successTitle}</h2>
                <p class="success-subtitle-v2">${d.successSubtitle}</p>
            </div>
        </div>
    </div>

    <div class="overlay" id="drawer-overlay"></div>
    `;

    const navContainer = document.createElement('div');
    navContainer.innerHTML = navHtml;
    document.body.prepend(navContainer);

    const contactForm = navContainer.querySelector('.contact-form');
    const inputs = contactForm ? contactForm.querySelectorAll('input, textarea') : [];
    const submitBtn = contactForm ? contactForm.querySelector('.btn-submit') : null;
    const statusMessage = navContainer.querySelector('#form-status-message');

    const openDrawer = (drawerId) => {
        const drawer = document.getElementById(drawerId);
        const overlay = document.getElementById('drawer-overlay');
        if (drawer) drawer.classList.add('active');
        if (overlay) overlay.classList.add('active');
        document.body.classList.add('drawer-open');
    };

    const resetFormState = () => {
        const success = document.getElementById('contact-success');
        const formContainer = document.getElementById('contact-form-container');
        if (success && formContainer) {
            success.style.display = 'none';
            success.style.opacity = '0';
            success.style.transform = 'translateY(20px)';
            formContainer.style.display = 'block';
            formContainer.style.opacity = '1';
            formContainer.style.transform = 'translateY(0)';
            
            document.getElementById('main-contact-form')?.reset();
            inputs.forEach(input => input.classList.remove('is-valid', 'is-invalid'));

            if (statusMessage) statusMessage.textContent = '';

            if (submitBtn) {
                submitBtn.disabled = false;
                const submitText = submitBtn.querySelector('span');
                if (submitText) submitText.textContent = d.formSubmit;
            }
            
            if (window.turnstile) {
                window.turnstile.reset();
            }
        }
    };

    const closeAllDrawers = () => {
        const drawers = document.querySelectorAll('.drawer');
        const overlay = document.getElementById('drawer-overlay');
        drawers.forEach(d => d.classList.remove('active'));
        if (overlay) overlay.classList.remove('active');
        document.body.classList.remove('drawer-open');
        
        setTimeout(resetFormState, 500);
    };

    document.addEventListener('click', (e) => {
        if (e.target.closest('.toggle-contact')) {
            e.preventDefault();
            resetFormState();
            openDrawer('contact-drawer');
        }
        if (e.target.closest('#open-menu')) {
            e.preventDefault();
            openDrawer('menu-drawer');
        }
        if (e.target.closest('.close-btn') || e.target.closest('#drawer-overlay')) {
            closeAllDrawers();
        }
    });

    function validateEmail(email) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }

    inputs.forEach(input => {
        input.addEventListener('input', () => {
            let isValid = input.checkValidity();
            if (input.type === 'email' && isValid) {
                isValid = validateEmail(input.value);
            }

            if (input.value.length > 0) {
                if (isValid) {
                    input.classList.add('is-valid');
                    input.classList.remove('is-invalid');
                } else {
                    input.classList.add('is-invalid');
                    input.classList.remove('is-valid');
                }
            } else {
                input.classList.remove('is-valid', 'is-invalid');
            }
        });
    });

    if (contactForm && submitBtn) {
        contactForm.addEventListener('submit', (e) => {
            e.preventDefault();
            
            let isFormValid = true;
            inputs.forEach(input => {
                let isValid = input.checkValidity();
                if (input.type === 'email' && isValid) {
                    isValid = validateEmail(input.value);
                }
                
                if (!isValid) {
                    input.classList.add('is-invalid');
                    isFormValid = false;
                }
            });

            if (!isFormValid) return;

            if (statusMessage) {
                statusMessage.textContent = d.sendingLabel;
            }
            submitBtn.disabled = true;

            // Préparation des données proprement nettoyées au format JSON pour n8n
            const payload = {
                firstname: contactForm.querySelector('[name="firstname"]')?.value || '',
                lastname: contactForm.querySelector('[name="lastname"]')?.value || '',
                email: contactForm.querySelector('[name="email"]')?.value || '',
                phone: contactForm.querySelector('[name="phone"]')?.value || '',
                message: contactForm.querySelector('[name="message"]')?.value || '',
                'cf-turnstile-response': contactForm.querySelector('[name="cf-turnstile-response"]')?.value || '',
                lang: lang
            };

            // Envoi direct à n8n (Remplacez l'URL par votre vrai webhook)
            fetch('https://n8n.spicedworks.top/webhook/9b2d2a78-5718-4523-85d1-62248588f845', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Server returned ' + response.status);
                }
                return response.json();
            })
            .then(data => {
                // n8n doit répondre un JSON contenant {"success": true}
                if (data && data.success) {
                    if (statusMessage) statusMessage.textContent = '';

                    const formContainer = document.getElementById('contact-form-container');
                    const success = document.getElementById('contact-success');
                    
                    formContainer.style.transition = 'all 0.4s ease-out';
                    formContainer.style.opacity = '0';
                    formContainer.style.transform = 'translateY(-20px)';
                    
                    setTimeout(() => {
                        formContainer.style.display = 'none';
                        success.style.display = 'flex';
                        success.offsetHeight; 
                        success.style.opacity = '1';
                        success.style.transform = 'translateY(0)';
                    }, 400);

                    setTimeout(closeAllDrawers, 3500);
                } else {
                    const errMsg = data && data.message ? data.message : (lang === 'en' ? 'An error occurred. Please try again.' : 'Une erreur est survenue. Veuillez réessayer.');
                    alert(errMsg);
                    
                    if (statusMessage) statusMessage.textContent = '';
                    submitBtn.disabled = false;
                    if (window.turnstile) window.turnstile.reset();
                }
            })
            .catch(error => {
                console.error('Error submitting form to n8n:', error);
                alert(lang === 'en' ? 'Unable to connect to the server. Please try again.' : 'Impossible de se connecter au serveur. Veuillez réessayer.');
                
                if (statusMessage) statusMessage.textContent = '';
                submitBtn.disabled = false;
                if (window.turnstile) window.turnstile.reset();
            });
        });
    }
}